import { captureException } from "@nais/apm";
import { getAnalyticsInstance } from "@navikt/nav-dekoratoren-moduler";
import type { Events } from "@/common/analytics/events";
import type { Audience } from "@/common/hooks/routeHooks";
import { isDemoOrLocal } from "@/common/publicEnv";

const combineEventData = (
  audience: Audience,
  eventData?: Record<string, string>,
) => ({
  team: "eSyfo",
  app: "dialogmote-frontend",
  audience,
  ...eventData,
});

// Prefer using the useAnalytics hook to using this directly
export const sendTrackingEvent = async (
  audience: Audience,
  eventName: Events,
  eventData?: Record<string, string>,
): Promise<void> => {
  if (isDemoOrLocal) {
    console.log(
      `Analytics event: ${eventName}, eventProperties:\n${JSON.stringify(
        combineEventData(audience, eventData),
        null,
        2,
      )}`,
    );
    return;
  }

  try {
    const log = getAnalyticsInstance("dialogmote");
    await log.custom(eventName, combineEventData(audience, eventData));
  } catch (error) {
    const msg =
      typeof error === "string" ? error : (error as Error)?.message || "";
    if (msg.includes("Analytics instance not found")) {
      return; // Ignore, user has not consented to analytics
    }
    captureException(
      error instanceof Error ? error : new Error("Analytics logging failed"),
      { context: { event: eventName } },
    );
  }
};
